import { render, staticRenderFns } from "./unreplyDetail.vue?vue&type=template&id=1ec0a2b9&scoped=true"
import script from "./unreplyDetail.vue?vue&type=script&lang=js"
export * from "./unreplyDetail.vue?vue&type=script&lang=js"
import style0 from "./unreplyDetail.vue?vue&type=style&index=0&id=1ec0a2b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec0a2b9",
  null
  
)

export default component.exports